import React from 'react'
import cx from 'classnames'
import {getBadgingTableColumns} from './columns'
import { useTranslation } from 'react-i18next';

export default function BadgingTable(props) {
  const {
    reportData, 
    selectedRows, 
    selectedCells, 
    isTableChecked,
    toggleTable,
    toggleColumn,
    toggleRow,
    toggleCell,
    badgingLocale,
  } = props;

  const columns = getBadgingTableColumns(badgingLocale)

  const {t} = useTranslation("badging_report")

  return (
    <table className='badgingTable'>
      <thead>
        <tr className='badgingTableHeaderRow badgingTableRow'>
          <th className='badgingTableHeaderCell'>
            <input
              type="checkbox"
              checked={isTableChecked}
              onChange={toggleTable}
            />
          </th>
          {columns.map((col, i) => {
            const className = cx({
              'badgingTableHeaderCell': true,
              'badgingTableHeaderClickable': col.badgeTypeId
            })
            let columnLabel = t(col.label)
            if (col.locale === 'ES_MX') columnLabel += ` (${t('Spanish')})`;
            return (
              <th 
                key={i}
                className={className}
                onClick={() => toggleColumn(col.badgeTypeId)}
              >
                {columnLabel}
              </th>
            )
          })}
        </tr>
      </thead>   
      <tbody>
        {reportData.map((row) => {
          row.studentCellSelection = selectedCells[row.studentId] || []
          row.toggleCell = toggleCell;
          return (
            <tr key={row.studentId} className='badgingTableRow'>
              <td className='badgingTableCell' style={{ textAlign: "center" }}>
                <input 
                  type="checkbox"
                  checked={selectedRows.includes(row.studentId)}
                  onChange={() => toggleRow(row.studentId)} 
                />
              </td>
              {columns.map((col, i) => {
                let className = 'badgingTableCell ';
                if (col.cellClassName) className += col.cellClassName;
                if (col.isHidden && col.isHidden(row)) return null;
                const colSpan = col.colSpan && col.colSpan(row) || 1;
                return (
                  <td className={className} key={i} colSpan={colSpan}>
                    {col.render(row)}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}